import { Button, Box, Typography } from '@mui/material'
import { useIsBoAdminRole } from 'hooks/useIsBoAdminRole'
import { useState } from 'react'

type Props = {
  logs: string[] | null
}

export default function Logs({ logs }: Props) {
  const isAdminRole = useIsBoAdminRole()

  const [showLogs, setShowLogs] = useState<boolean>(false)
  if (isAdminRole && logs && logs.length > 0) {
    return (
      <>
        <Button
          variant="contained"
          onClick={() => setShowLogs(!showLogs)}
          sx={{
            width: 500,
          }}>
          {showLogs ? <>Hide logs</> : <>Show logs (admin)</>}
        </Button>
        {showLogs && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <h3>Logs:</h3>

            {logs.map(row => (
              <Typography pb={0.5} fontSize={14} sx={{ whiteSpace: 'pre-line' }}>
                {row}
              </Typography>
            ))}
          </Box>
        )}
      </>
    )
  }
  return null
}
